<!--
 * @Author: xuchen
 * @Date: 2020-03-10 18:20:35
 * @Desc: 企业基本信息
 -->
<template>
  <div class="wonitor-resource-info">
    <div class="panel-tit flex items-center justify-between">
      <div class="flex items-center">
        <span>基本信息</span>
      </div>
      <i
        :class="[isFold ? 'h-icon-angle_up' : 'h-icon-angle_down', 'arrow-icon']"
        @click="handleFold"
      ></i>
    </div>
    <div v-show="!isFold" class="content">
      <div class="msg-item-container">
        <div class="tit">
          行业分类/企业性质
        </div>
        <div class="info-container flex justify-between">
          <div>{{ dataProvider.industry }}</div>
          <div>{{ dataProvider.enterprisePropertyStr }}</div>
        </div>
      </div>
      <div class="msg-item-container">
        <div class="tit">
          企业负责人
        </div>
        <div class="info-container flex justify-between">
          <div v-ellipsis>{{ dataProvider.enterprisePersonName }}</div>
          <div v-ellipsis style="textAlign:right">{{ dataProvider.enterprisePersonPhoneNum }}</div>
        </div>
      </div>
      <div class="msg-item-container">
        <div class="tit">
          安全负责人
        </div>
        <div class="info-container flex justify-between">
          <div v-ellipsis>{{ dataProvider.safetyOfficerName }}</div>
          <div v-ellipsis style="textAlign:right">{{ dataProvider.safetyOfficerPhoneNum }}</div>
        </div>
      </div>
      <div class="msg-item-container">
        <div class="tit">
          企业地址
        </div>
        <div v-ellipsis class="info-container">
          {{ dataProvider.enterpriseAddress }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseInfo',
  props: {
    dataProvider: {
      // 罐体信息
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isFold: false // 是否折叠
    }
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-03 17:37:09
     * @desc 折叠操作
     */
    handleFold() {
      this.isFold = !this.isFold
    }
  }
}
</script>

<style lang="scss" scoped>
.wonitor-resource-info {
  .panel-tit {
    height: 32px;
    line-height: 32px;
    padding-left: 8px;
    padding-right: 11px;
    background: rgba(0, 0, 0, 0.08);
  }
  .arrow-icon {
    font-size: 16px;
    cursor: pointer;
  }
  .content {
    padding: 8px 12px 0;
  }
  .tit {
    padding-bottom: 4px;
    color: rgba(0, 0, 0, 0.4);
  }
  .msg-item-container {
    padding-bottom: 20px;
  }
  .info-container {
    color: rgba(0, 0, 0, 0.7);
  }
}
</style>
